import React, {useEffect, useState} from "react";
import "./style.css";
import animationData from "../../../../../static/json/questionnaire/weight-loss/LoseWeightFaster.json";
import Lottie from "react-lottie";

export const MobileLoseWeightFaster = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
      if (isCurPage) {
          setIsPaused(false);
      } else {
          setIsPaused(true);
      }
    }, [isCurPage]);


  return (
    <div className="lose-weight-faster-mobile" data-model-id="16761:860">

      <div className="div">
        <p className="title">
          <span className="text-wrapper">Lose </span>

          <span className="span">2X</span>

          <span className="text-wrapper">
            {" "}
            much weight with Calo vs. trying on your own
          </span>
        </p>

        <Lottie
            options={{
              loop: false,
              autoplay: false,
              animationData: animationData,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
            height={"calc(100vw * 290 / 375)"}
            width={"calc(100vw * 335 / 375)"}
            isPaused={isPaused} />

        <div className="content-container">
          <p className="description">
            Calo makes it easy and holds you accountable.
          </p>
        </div>
      </div>

    </div>
  );
};
